export default __webpack_public_path__ + "static/media/argus_logo.ca129204.png";